import $ from 'jquery';
import RuntimeUtils from 'src/common/js/runtimeUtils';
import { $get } from 'src/utils/httpUtil';
import * as SparkMD5 from 'spark-md5';

// 空间大小统计
export const getSpaceCapacity = () =>
    new Promise((resolve, reject) => {
        const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/stats/spaceCapacity`;
        $get(url).then((res) => {
            resolve(res);
        });
    });

// 任务转换数量统计
export const getJobCount = () =>
    new Promise((resolve, reject) => {
        const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/stats/jobCount`;
        $get(url).then((res) => {
            resolve(res);
        });
    });

// 任务转换数量趋势图
export const getJobTrend = (type = 1) =>
    new Promise((resolve, reject) => {
        const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/stats/jobTrend`;
        const data = {
            type,
        };
        $get(url, data).then((res) => {
            resolve(res);
        });
    });

export const getFileMd5 = function (uploadFile, config) {
    let isCancel = false;
    let cancelMessage = '取消分片计算';
    const cancelHash = (message) => {
        isCancel = true;
        if (message) {
            cancelMessage = message;
        }
    };
    if (config.cancelToken) {
        config.cancelToken = cancelHash;
    }
    return new Promise((resolve, reject) => {
        const blobSlice = File.prototype.slice || File.prototype['mozSlice'] || File.prototype['webkitSlice'];
        const file = uploadFile;
        const chunkSize = 2097152; // Read in chunks of 2M;
        const chunks = Math.ceil(file.size / chunkSize);
        let currentChunk = 0;
        const spark = new SparkMD5.ArrayBuffer();
        const fileReader = new FileReader();
        fileReader.onload = function (e) {
            if (config.updatePercentage) {
                config.updatePercentage((currentChunk / chunks) * 100);
            }
            spark.append(e.target.result); // Append array buffer
            currentChunk++;

            if (!isCancel) {
                if (currentChunk < chunks) {
                    loadNext();
                } else {
                    const md5 = spark.end();
                    if (config.updatePercentage) {
                        config.updatePercentage(100);
                    }
                    resolve(md5);
                }
            } else {
                spark.end();
                reject(cancelMessage);
            }
        };

        fileReader.onerror = () => {
            console.warn('oops, something went wrong.');
            reject({
                message: 'Calculate Fail',
            });
        };

        const loadNext = () => {
            const start = currentChunk * chunkSize;
            const end = start + chunkSize >= file.size ? file.size : start + chunkSize;

            fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
        };

        loadNext();
    });
};



// WEBPACK FOOTER //
// ./src/utils/calculateUtils.js